import { createContext } from "react"
import { CurriculumBook } from "shared/types/curriculumTypes"

export const BookContext = createContext<{ textbooks: CurriculumBook[] }>(({
    textbooks: []
}))


